import * as React from "react";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import {none, option, Option} from "ts-option";
import {connect, Dispatch} from "react-redux";
import {Icon} from "../../hiberUiKit/src/atoms/Icon/Icon";
import DataGrid from "../../hiberUiKit/src/organisms/DataGrid/DataGrid";
import Account from "../../model/account/Account";
import {PartnerBrandSearch} from "../../model/partnerBrand/PartnerBrand";
import CurrencyHelper from "../../helper/CurrencyHelper";
import {CommonDetailsStatusRow} from "./common/CommonDetailsStatusRow";
import {OnFailure, OnSuccessData} from "../../store/action/actionHelpers";
import {fetchPartnerBrandAccounts} from "../../store/action/partnerBrand/partnerBrand";
import {notifyBugsnagAndShowToast} from "../../utils/Utils";
import PartnerBrandSelectionComponent from "../partnerBrand/search/PartnerBrandSelectionComponent";

const arrow = require('../../../resources/hiber/img/guide-arrow.png');

interface DispatchProps {
	/**
	 * Fetch accounts
	 * @param {string} partnerBrandId
	 * @param {OnSuccessData<Account[]>} onSuccess
	 * @param {OnFailure} onFailure
	 */
	fetchAccounts: (partnerBrandId: string, onSuccess: OnSuccessData<Account[]>, onFailure: OnFailure) => void;
}

interface State {
	/**
	 * Accounts list.
	 */
	accounts: Option<Account[]>;
	/**
	 * Selected partner brand.
	 */
	selectedPartnerBrand: Option<PartnerBrandSearch>;
}

type Props = DispatchProps & RouteComponentProps<{}>;

/**
 * Accounts view.
 */
class AccountsView extends React.PureComponent <Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {accounts: none, selectedPartnerBrand: none};
	}

	fetchData = (): void => {
		this.state.selectedPartnerBrand.map(pb => {
			this.props.fetchAccounts(pb.id, (accounts) => {this.setState({accounts: option(accounts)})},
				(error) => notifyBugsnagAndShowToast(error, "Fetch accounts"));
		}).getOrElse(() => this.setState({accounts: none}));
	};

	render() {
		return (
			<div className={"l-page"}>
				<CommonDetailsStatusRow icon={Icon.Quote}
										title={"Chart of Accounts"}
										onBackClick={this.props.history.goBack}
										refNumPath={["Accounting", "Chart of accounts"]}
										additionalComponent={this.renderPartnerBrandSelector()}/>
				{this.renderTable()}
			</div>
		);
	}

	renderTable = () => {
		return this.state.selectedPartnerBrand.map(pb => {
			const accounts = this.state.accounts.getOrElse([]);
			if (!accounts.length) {
				return this.renderNoDataContent();
			}
			return (
				<DataGrid>
					<thead>
					<tr className="c-common-details_table-header-row">
						<th className="c-common-details_table-desc-cell low-width">NAME</th>
						<th>CODE</th>
						<th>DESCRIPTION</th>
						<th>TYPE</th>
						<th>TAX TYPE</th>
						<th>BALANCE</th>
					</tr>
					</thead>
					<tbody>
					{accounts.map((item) =>
						<tr key={item.id} className="c-common-details_table-row">
							<td className="c-common-details_table-desc-cell low-width">{item.name}</td>
							<td>{item.code}</td>
							<td>{item.description.getOrElse("")}</td>
							<td>{item.type}</td>
							<td>{item.taxType}</td>
							<td>{CurrencyHelper.toCurrency(item.balance)}</td>
						</tr>)}
					</tbody>
				</DataGrid>);
		}).getOrElse(this.renderNoPbSelectedContent);
	};

	renderPartnerBrandSelector = () => {
		return (
			<div className="c-common-details_partner-brand-selector">
				<PartnerBrandSelectionComponent selectedValue={this.state.selectedPartnerBrand}
												onSelect={this.onPartnerBrandChange}
												placeholder="Choose a partner brand..."/>
			</div>
		);
	};

	renderNoPbSelectedContent = () => {
		return (
			<div>
				<img src={arrow} className="c-common-details_no-pb-selected-warning_partner-brand-guide-arrow"/>
				<div className="c-common-details_no-pb-selected-warning_text">
					Please choose a partner brand to continue.
				</div>
			</div>
		);
	};

	renderNoDataContent = () => {
		return (
			<div className="c-common-details_no-pb-selected-warning_text">
				No data for selected partner brand.
			</div>
		);
	};

	onPartnerBrandChange = (selectedPartnerBrand: Option<PartnerBrandSearch>) => this.setState({selectedPartnerBrand},
		this.fetchData);
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchAccounts: (partnerBrandId: string, onSuccess: OnSuccessData<Account[]>, onFailure: OnFailure) =>
			dispatch(fetchPartnerBrandAccounts(partnerBrandId, onSuccess, onFailure))
	}
}

export default withRouter(connect(null, mapDispatchToProps)(AccountsView))
